<template>
  <div class="ma-4">
   
   <ClientNav/>
   <v-row dense>
    <v-col cols="12" lg="3" xl="2">
      <ClientSide />
    </v-col>
    <v-col cols="12" lg="9" xl="10">
      <v-card class="pa-2" outlined tile height="100%">
        <TimesheetTable />
      </v-card>
    </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
import ClientNav from '../components/StaffNav'
import ClientSide from '../components/StaffSide'
import Foot from '../components/Footer'
import TimesheetTable from '../components/Timesheet/Table'

export default {
  components: {
      ClientNav,
      ClientSide,
      Foot,
      TimesheetTable
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }

  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }

  }
</style>